import ProductsSearchResult from '@components/ProductsSearchResult';
import { ICollection, ICollectionProductBasket } from '@monofront/types';
import {
  CollectionBreadcrumb,
  Description,
  GoBackLink,
  HeroCollection,
  SiblingCollectionsCardList,
  CarouselProductBasket,
} from '@screens/Collection/components';
import CarouselTags from '@components/CarouselTags';
import ScrollToTop from '@components/ScrollToTop';
import { useTranslations } from 'next-intl';

type CollectionProductsProps = {
  collection: ICollection;
  collectionProductBasket?: ICollectionProductBasket | null;
  siblingCollections?: ICollection[] | null;
};

export const CollectionProducts: React.FC<CollectionProductsProps> = ({
  collection,
  collectionProductBasket,
  siblingCollections,
}) => {
  const tCatalog = useTranslations('Catalog');

  return (
    <div className="limited-width-container tw-flex tw-flex-col">
      <div className="tw-px-4 tw-pt-3 desktop:tw-hidden">
        <GoBackLink
          currentPathTitle={collection.title}
          breadcrumb={collection.breadcrumb}
        />
        <p className="title-xs tw-pb-2 tw-pt-3">{collection.title}</p>
        {collection.childCollections != null &&
          collection.childCollections.length > 0 && (
            <div className="tw-my-2">
              <CarouselTags tagList={collection.childCollections} />
            </div>
          )}
      </div>
      <div className="tw-mb-6 tw-mt-4 tw-hidden desktop:tw-block">
        <CollectionBreadcrumb
          breadcrumb={collection.breadcrumb}
          currentPathTitle={collection.title}
        />
      </div>
      <div className="tw-order-2 tw-flex tw-justify-center tw-py-6 tw-text-center desktop:tw-hidden">
        <ScrollToTop />
      </div>
      <div className="tw-order-1 tw-my-6 desktop:tw-order-none desktop:tw-mt-0">
        <HeroCollection
          title={collection.title}
          image={collection.image}
          descriptionHtml={collection.short_description || ''}
          childCollections={collection.childCollections}
        />
      </div>
      <div>
        <CarouselProductBasket
          collectionProductBasket={collectionProductBasket}
        />
      </div>
      <div className="desktop:tw-my-6">
        <ProductsSearchResult
          collectionHandle={collection.handle}
          collectionLevel={collection.breadcrumb.length}
        />
      </div>
      <SiblingCollectionsCardList
        siblingCollections={siblingCollections}
        UNSAFE_className="tw-mb-14 tw-mx-3"
      />
      {collection.short_description && (
        <div className="tw-px-4 desktop:tw-hidden">
          <h2 className="title tw-pb-4">{tCatalog('whyThisSelection')}</h2>
          <Description description={collection.short_description} />
        </div>
      )}
      <Description
        description={collection.body_html}
        UNSAFE_className="tw-mb-10 tw-mx-3"
      />
    </div>
  );
};
